<template>
  <div>
    <v-card>
      <v-card-title>
      <v-icon color="primary">
        mdi-poll
      </v-icon>
        <span class="px-2">{{$t('reservations')}}</span>
      </v-card-title>
      <v-tabs v-model="active_tab" show-arrows class="my-2">
        <v-tab v-for="tab in translatedTabs" :key="tab.idx">
          <v-icon size="20" class="me-3">
            {{ tab.icon }}
          </v-icon>
          <span>{{ tab.title }}</span>
        </v-tab>
      </v-tabs>
    <v-tabs-items v-model="active_tab">
      <!-- active -->
      <v-tab-item>
        <reservations-table
        :show-cancel="true"
        :loading="isLoading"
        :reservations="activeReservations"
        @cancel-reservation="cancelReservation"
        ></reservations-table>
      </v-tab-item>

      <!-- ride -->
      <v-tab-item>
        <reservations-table
        :show-cancel="true"
        :loading="isLoading"
        @cancel-reservation="cancelReservation"
        :reservations="rideReservations"></reservations-table>
      </v-tab-item>

      <!-- missed -->
      <v-tab-item>
        <reservations-table
        :show-cancel="true"
        :loading="isLoading"
        @cancel-reservation="cancelReservation"
        :reservations="missedReservations"></reservations-table>
      </v-tab-item>

      <!-- completed -->
      <v-tab-item>
        <reservations-table
        :show-cancel="true"
        :loading="isLoading"
        @cancel-reservation="cancelReservation"
        :reservations="completedReservations"></reservations-table>
      </v-tab-item>

      <!-- cancelled -->
      <v-tab-item>
        <reservations-table
        :show-cancel="false"
        :loading="isLoading"
        :reservations="cancelledReservations"></reservations-table>
      </v-tab-item>

    </v-tabs-items>
    </v-card>
  </div>
</template>

<script>

import {
  mdiStopCircleOutline,
  mdiAccountCheck,
  mdiAccountClock,
  mdiAccountOff,
  mdiPlayCircleOutline,
  mdiTrashCan,
  mdiDeleteRestore,
  mdiAirplane,
  mdiMotionPause
} from "@mdi/js";

import reservationsTable from './reservations-table.vue';

export default {
  components: {
    reservationsTable
  },
  data() {
    return {
      activeReservations: [],
      rideReservations: [],
      completedReservations: [],
      missedReservations: [],
      cancelledReservations: [],
      isLoading: false,
      selectedReservation: null,
      search: "",
      tabs: [
        { idx: 0, title: "upcoming", icon: mdiPlayCircleOutline },
        { idx: 1, title: "ride", icon: mdiAccountClock },
        { idx: 2, title: "missed", icon: mdiAccountOff },
        { idx: 3, title: "completed", icon: mdiAccountCheck },
        { idx: 4, title: "cancelled", icon: mdiMotionPause },
      ],
      active_tab: null,
      icons: {
        mdiStopCircleOutline,
        mdiAccountCheck,
        mdiAccountOff,
        mdiAccountClock,
        mdiPlayCircleOutline,
        mdiTrashCan,
        mdiDeleteRestore,
        mdiAirplane
      },
    };
  },
  watch: {
    active_tab: function (newVal, oldVal) {
      localStorage.tabIdxReservations = newVal;
    },
  },
  computed: {
    translatedTabs() {
      return this.tabs.map(tab => ({
        ...tab,
        title: this.$t(tab.title)
      }));
    },
  },
  mounted() {
    this.active_tab = parseInt(localStorage.tabIdxReservations);
    this.loadReservations();
  },
  methods: {
    loadReservations() {
      this.isLoading = true;
      this.reservations = [];
      axios
        .get(`/reservations/all`)
        .then((response) => {
          this.activeReservations = response.data.active;
          this.rideReservations = response.data.ride;
          this.completedReservations = response.data.completed;
          this.missedReservations = response.data.missed;
          this.cancelledReservations = response.data.cancelled;

        })
        .catch((error) => {
          this.$notify({
            title: "Error",
            text: this.$t("error_retrieving_reservations"),
            type: "error",
          });
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    cancelReservation(reservation, index) {
      let title = "";
      if(this.active_tab >= 1 && this.active_tab <= 3)
      {
        title = this.$t("cancel_reservation_warning");
      }
      else
      {
        title = this.$t("cancel_reservation_simple");
      }
      this.$swal({
        title: this.$t("are_you_sure"),
        text: title,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yes_cancel_it"),
        cancelButtonText: this.$t("cancel"),
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post(`/reservations/cancel`, {
              id: reservation.id,
              reason: "Cancelled by admin",
            })
            .then((response) => {
              this.$notify({
                title: "Success",
                text: this.$t("reservation_cancelled_successfully"),
                type: "success",
              });
              if(response.status == 201)
                this.$swal("Info", response.data.message, "info");
              let reservationToCancel = null
              if(this.active_tab == 0)
              {
                reservationToCancel = this.activeReservations[index];
                this.activeReservations.splice(index, 1);
              }
              else if(this.active_tab == 1)
              {
                reservationToCancel = this.rideReservations[index];
                this.rideReservations.splice(index, 1);
              }
              else if(this.active_tab == 2)
              {
                reservationToCancel = this.missedReservations[index];
                this.missedReservations.splice(index, 1);
              }
              else if(this.active_tab == 3)
              {
                reservationToCancel = this.completedReservations[index];
                this.completedReservations.splice(index, 1);
              }
              this.cancelledReservations.push(reservationToCancel);
            })
            .catch((error) => {
              this.$notify({
                title: "Error",
                text: this.$t("error_cancelling_reservation"),
                type: "error",
              });
              console.log(error);
              this.$swal("Error", error.response.data.message, "error");
            });
        }
      });
    },
  },
};
</script>
